<mat-dialog-content *ngIf="data">
    <p>{{ data.message | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="warn" *ngIf="data.isConfirm" mat-dialog-close>{{'LABEL.NO' | translate}}</button>
  <button mat-flat-button color="accent" *ngIf="data.isConfirm" [mat-dialog-close]="true">{{'LABEL.YES' | translate}}</button>
  <button mat-flat-button color="accent" *ngIf="!data.isConfirm" [mat-dialog-close]="true">{{'LABEL.OK' | translate}}</button>
</mat-dialog-actions>